var api = require("!../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../node_modules/css-loader/dist/cjs.js!./app.global.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = function (element) {
                                document.querySelector('head').prepend(element);
                            };
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};